module.exports = __webpack_public_path__ + "static/img/the-last-jedi.66dca2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid/the-last-jedi.jpg
// module id = Z70t
// module chunks = 0